import type { TabKey } from '@/components/base/BaseTab.vue'

export default function useWalletTabs() {
  const { t } = useI18n()
  const route = useRoute()

  const currentTab = ref((route?.query?.activeTab as string) ?? 'config')
  const tabs = ref<TabKey[]>([
    {
      value: 'config',
      name: t('pages.loyaltySupports.wallet.tabs.config'),
      icon: 'HeroCog6ToothIconOutline'
    },
    {
      value: 'stats',
      name: t('pages.loyaltySupports.wallet.tabs.stats'),
      icon: 'HeroChartBarIconOutline'
    }
  ])

  return {
    tabs,
    currentTab
  }
}
